import { formatCurrency, formatDate } from '~/common/util/format';

/**
 * @function formatValues - Formats the value based on the method provided
 * @param {string} method - Type of formatting to apply
 * @param {*} value - Value to format
 * @param {*} defaultValue - Default value to return if value is not valid
 * @returns {string} - The formatted value
 */

const formatValues = (method, value, defaultValue = '') => {
  switch (method) {
    case 'currency': {
      return Number.isNaN(Number.parseInt(value))
        ? formatCurrency(defaultValue)
        : formatCurrency(value);
    }
    case 'date':
      return value ? formatDate(value) : '';
    default:
      return value;
  }
};

export default formatValues;
